"use strict";
// !has('build-elide')
require('wicg-inert/dist/inert');